import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[focusDirective]'
})
export class FocusDirective {

  constructor(el: ElementRef,) {
    setTimeout(() => el.nativeElement.focus(), 0)
  }
}